import { useTranslations } from 'next-intl';
import React, { Dispatch, SetStateAction, useLayoutEffect, useState } from 'react';

import Button from '@cineamo/ui/src/button/NewButton';
import Countdown, { CountdownApi } from '@cineamo/ui/src/countdown/Countdown';
import Modal from '@cineamo/ui/src/modals/Modal';

const CountdownInfoModal: React.FC<{
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    targetTimestamp: number;
}> = ({ isOpen, setIsOpen, targetTimestamp }) => {
    const t = useTranslations();
    const [countdownRef, setCountdownRef] = useState<CountdownApi | null | null>(null);
    useLayoutEffect(() => {
        if (isOpen) {
            countdownRef?.start();
        } else {
            countdownRef?.stop();
        }
    }, [isOpen, countdownRef]);

    return isOpen ? (
        <Modal
            className="max-w-[480px]"
            modalIsOpen={isOpen}
            setModalIsOpen={setIsOpen}
            onClose={() => setIsOpen(false)}
            title={t('tickets.session-timeout-in')}>
            <div className="flex flex-col space-y-16">
                <h2 className="text-headline-24 self-center">
                    <Countdown
                        targetTimestamp={targetTimestamp}
                        autoStart={false}
                        ref={setCountdownRef}
                    />
                </h2>
                <p>{t('tickets.session-timeout-in-message')}</p>
                <Button
                    onClick={() => setIsOpen(false)}
                    labelClassName="text-body-bold-16"
                    className="min-h-[48px]">
                    {t('common.continue')}
                </Button>
            </div>
        </Modal>
    ) : null;
};

export default CountdownInfoModal;
